import {APP_INITIALIZER, DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TopbarComponent } from './shared/topbar/topbar.component';
import { MenuComponent } from './shared/menu/menu.component';
import { FooterComponent } from './shared/footer/footer.component';
import { SharedModule } from './shared/shared.module';
import {CommonModule, registerLocaleData} from '@angular/common';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UiModule } from './ui/ui.module';
import { AuthService } from './auth/auth.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApiJwtInterceptor } from './auth/api-jwt.interceptor';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthGuard } from './auth/guards/auth.guard';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import {TranslateModule} from '@ngx-translate/core';
import {RoleGuard} from './auth/guards/role.guard';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

@NgModule({ declarations: [
        AppComponent,
        TopbarComponent,
        MenuComponent,
        FooterComponent
    ],
    exports: [],
    bootstrap: [AppComponent], imports: [BrowserModule,
        TranslateModule.forRoot({
            defaultLanguage: 'de'
        }),
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        UiModule], providers: [
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {
            },
            deps: [Sentry.TraceService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiJwtInterceptor,
            multi: true
        },
        {
            provide: JwtHelperService,
            useFactory: () => new JwtHelperService()
        },
        AuthService, AuthGuard, RoleGuard,
        {
            provide: LOCALE_ID,
            useValue: 'de-DE'
        },
        {
            provide: DEFAULT_CURRENCY_CODE,
            useValue: 'EUR'
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
